import { Link } from 'react-router-dom';
import AdForgeLogo from '../../../components/feature/AdForgeLogo';

const footerLinks = {
  Industries: [
    { label: 'AI Ads for Contractors', href: '/ai-ads-for-contractors' },
    { label: 'AI Ads for Small Business', href: '/ai-ads-for-small-business' },
    { label: 'AI Ads for Ecommerce', href: '/ai-ads-for-ecommerce' },
    { label: 'AI Ads for Real Estate', href: '/ai-ads-for-real-estate' },
    { label: 'AI Ads for Local Services', href: '/ai-ads-for-local-services' },
  ],
  Product: [
    { label: 'Features', href: '/features' },
    { label: 'How It Works', href: '/how-it-works' },
    { label: 'AI Ad Generator', href: '/ai-ad-generator' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Dashboard', href: '/dashboard' },
    { label: 'Example Ads', href: '/#examples' },
  ],
  Company: [
    { label: 'About Us', href: '/about' },
    { label: 'Blog', href: '#' },
  ],
  Support: [
    { label: 'Help Center', href: '/contact' },
    { label: 'Contact Us', href: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms of Service', href: '/terms-of-service' },
  ],
};

const socials = [
  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/profile.php?id=61575473528873', label: 'Facebook' },
  { icon: 'ri-instagram-fill', href: 'https://www.instagram.com/ad_forgeai', label: 'Instagram' },
];

export default function Footer() {
  return (
    <footer className="bg-stone-100 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Link to="/" className="inline-block mb-5">
              <AdForgeLogo size="lg" light={false} />
            </Link>
            <p className="text-sm text-stone-500 leading-relaxed mb-6 max-w-xs">
              The AI-powered ad copy generator built for small businesses, contractors, and agencies who want to run better ads — faster.
            </p>
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-stone-200 text-stone-500 hover:bg-orange-500 hover:text-white transition-all duration-200"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-sm font-bold text-stone-800 uppercase tracking-widest mb-4">
                <a id={`footer-${category.toLowerCase()}`}>{category}</a>
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-stone-500 hover:text-orange-500 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-stone-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-stone-400">
            © 2026 AdForge AI. All rights reserved.
          </p>
          <div className="flex items-center gap-2 bg-stone-200 rounded-full px-4 py-1.5">
            <span className="w-2 h-2 rounded-full bg-green-500" />
            <span className="text-xs font-medium text-stone-600">All systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
